// extracted by mini-css-extract-plugin
export default {"Card":"OrdersPage_Card__cxHgX"};